import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectkeys'
})
export class ObjectKeys implements PipeTransform {

  transform(value:{}) {
    return Object.keys(value)
  }

}